import React from 'react';
import { Flashbar } from '@cloudscape-design/components';

interface UploadProgressIndicatorProps {
  isUploading: boolean;
  uploadProgress: number;
}

/**
 * Component for displaying upload progress
 */
const UploadProgressIndicator: React.FC<UploadProgressIndicatorProps> = ({
  isUploading,
  uploadProgress,
}) => {
  if (!isUploading) return null;

  return (
    <div
      style={{
        position: 'fixed',
        top: '20px',
        left: '50%',
        transform: 'translateX(-50%)',
        zIndex: 9999,
        width: '80%',
        maxWidth: '800px',
      }}
    >
      <Flashbar
        items={[
          {
            type: 'info',
            loading: uploadProgress < 100,
            header: uploadProgress < 100 ? 'Uploading Files' : 'Upload Complete',
            content: `Uploading files: ${uploadProgress}% complete`,
            id: 'uploading-files',
          },
        ]}
      />
    </div>
  );
};

export default UploadProgressIndicator;
